import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import AppSidebar from "../components/AppSidebar";
import "../assets/admin-style.css";

const { Content } = Layout;
const AppLayout = () => {
  return (
    <>
      <AppHeader />
      <Layout style={{ minHeight: "calc( 100vh - 76px )" }}>
        <AppSidebar />

        <Layout>
          <Content style={{ padding: "1rem" }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default AppLayout;
